import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material/';


export default function ConfirmDialog({ title, desc, doIfConfirmed, showDialog, onClose, cancelText = 'No', confirmText = 'Yes' }) {

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleYes = () => {
    handleClose();
    doIfConfirmed();
  };

  return (
    <Dialog
      open={!!showDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {desc}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ gap: 1, padding: '12px 16px' }}>
        <Button onClick={handleClose}>
          {cancelText}
        </Button>
        <Button onClick={handleYes} variant="contained" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}